"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomException = exports.Helper = void 0;
class Helper {
    /**
     * create form
     * @param form
     * @param options
     * @returns
     */
    static createForm(url, options, method = 'POST') {
        const form = document.createElement('form');
        form.action = url;
        form.method = method;
        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                const hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", options[key]);
                form.appendChild(hiddenField);
            }
        }
        return form;
    }
    /**
    * utility function to create and make post request
    * @param options
    * @param serviceurl
    * @param errorResolver
    * @param access_token??
    * @param headers??
    * @returns
    */
    static createHttpPromise(options, serviceurl, errorResolver, method, access_token, headers, formPayload) {
        return new Promise((resolve, reject) => {
            try {
                const http = new XMLHttpRequest();
                http.onreadystatechange = function () {
                    if (http.readyState == 4) {
                        if (http.responseText) {
                            resolve(JSON.parse(http.responseText));
                        }
                        else {
                            resolve(errorResolver);
                        }
                    }
                };
                http.open(method, serviceurl, true);
                if (!formPayload) {
                    http.setRequestHeader("Content-type", "application/json");
                }
                if (headers) {
                    for (const key in headers) {
                        if (headers.hasOwnProperty(key)) {
                            http.setRequestHeader(key, headers[key]);
                        }
                    }
                }
                if (access_token) {
                    http.setRequestHeader("Authorization", `Bearer ${access_token}`);
                }
                let acceptlanguage;
                if (headers === null || headers === void 0 ? void 0 : headers.acceptlanguage) {
                    acceptlanguage = headers.acceptlanguage;
                }
                else if (options === null || options === void 0 ? void 0 : options.acceptlanguage) {
                    acceptlanguage = options.acceptlanguage;
                }
                else {
                    acceptlanguage = window === null || window === void 0 ? void 0 : window.localeSettings;
                }
                if (acceptlanguage) {
                    http.setRequestHeader("accept-language", acceptlanguage);
                }
                if (formPayload) {
                    http.send(formPayload);
                }
                else if (options) {
                    http.send(JSON.stringify(options));
                }
                else {
                    http.send();
                }
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    static getAccessTokenFromUserStorage(userManager) {
        return new Promise((resolve, reject) => {
            try {
                userManager.getUser().then((user) => {
                    resolve(user === null || user === void 0 ? void 0 : user.access_token);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    /**
     * To set accept language
     * @param acceptLanguage
     */
    static setAcceptLanguageHeader(acceptLanguage) {
        window.localeSettings = acceptLanguage;
    }
}
exports.Helper = Helper;
class CustomException {
    constructor(errorMessage, statusCode) {
        this.errorMessage = errorMessage;
        this.statusCode = statusCode;
    }
}
exports.CustomException = CustomException;
